import { useEffect,useState } from "react";
import { apiFetchBlob } from "@/shared/api/http";

export function PrivateMediaImage({path,alt,className}:{path:string;alt:string;className?:string}) {
  const [url,setUrl]=useState<string|null>(null);
  useEffect(()=>{
    let active=true; let objectUrl:string|null=null;
    apiFetchBlob(path).then(blob=>{objectUrl=URL.createObjectURL(blob);if(active)setUrl(objectUrl);else URL.revokeObjectURL(objectUrl)}).catch(()=>{});
    return()=>{active=false;if(objectUrl)URL.revokeObjectURL(objectUrl)};
  },[path]);
  return url?<img src={url} alt={alt} loading="lazy" className={className??"h-24 w-24 rounded-xl object-cover"}/>:<span className={className??"h-24 w-24 rounded-xl bg-white/5"} aria-label="Carregando imagem"/>;
}
